import { createFormHook, createFormHookContexts } from '@tanstack/react-form';

/**
 * Shared TanStack-form contexts + hook for the External agent edit page. Using `createFormHook`
 * gives us a properly-typed `useAppForm` and `withForm` so that ToolCard/ResourceCard/etc. can
 * declare their slice of the form without us hand-rolling a `ReactFormExtendedApi<…, any × 11>`
 * alias.
 *
 * No field/form component overrides are registered — the cards still build their own inputs
 * from `@gravity-ui/uikit` directly.
 */
export const { fieldContext, formContext } = createFormHookContexts();

export const { useAppForm, withForm } = createFormHook({
    fieldComponents: {},
    formComponents: {},
    fieldContext,
    formContext,
});
